import { reportEntitiesGQLFields, } from './reportEntitiesFields.js';
const BASIC_REPORT_PAYLOAD_FIELDS = {};
const ALL_REPORT_PAYLOAD_FIELDS = {
    entities: 'basic',
};
export const reportRecordGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_REPORT_PAYLOAD_FIELDS;
    if (fields === 'all')
        fields = ALL_REPORT_PAYLOAD_FIELDS;
    return `
    payload {
      key
      value
    }
    ${fields.entities
        ? `
    entities {
      ${reportEntitiesGQLFields(fields === null || fields === void 0 ? void 0 : fields.entities)}
    }
    `
        : ``}
  `;
};
//# sourceMappingURL=reportRecord.fields.js.map